module.exports = __webpack_public_path__ + "static/bluebunnysuitcase-ca59310b3c5bcd874867c296020b7b2d.jpeg";